module.exports = __webpack_public_path__ + "files/e1785066b65f7b9814f66075967510cd.png";